import { Injectable, signal } from '@angular/core';
import {
  DEFAULT_LANDING_THEME,
  isLandingThemeId,
  LANDING_THEME_STORAGE_KEY,
  LandingThemeId,
} from './landing-themes.config';

@Injectable({ providedIn: 'root' })
export class LandingThemeService {
  readonly activeTheme = signal<LandingThemeId>(this.readStoredTheme());

  setTheme(themeId: LandingThemeId): void {
    this.activeTheme.set(themeId);
    localStorage.setItem(LANDING_THEME_STORAGE_KEY, themeId);
  }

  private readStoredTheme(): LandingThemeId {
    if (typeof localStorage === 'undefined') {
      return DEFAULT_LANDING_THEME;
    }

    const stored = localStorage.getItem(LANDING_THEME_STORAGE_KEY);
    return isLandingThemeId(stored) ? stored : DEFAULT_LANDING_THEME;
  }
}
